//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../api/common'
    export default {
        data() {
            return {
                orederId: this.$route.query.id,
                orderType: this.$route.query.type,
                state: '',
                service: '',
                doctor: {},//医生信息
                patient: {},//患者信息
                orderinfo: {},//问诊订单信息
                buyedtime:'',
            }
        },
        // 生命周期之挂载完成
        methods: {
            //获取订单详情
            getOrderDetails(){
                let params = {
                    /*是否获取问诊订单详情信息 1 获取2 不获取*/
                    getOrder: '1',
                    /*订单id*/
                    orderID: this.orederId,
                    /*是否获取医生详情信息 1 获取2 不获取*/
                    getDoctor: '1',
                    /*是否获取问诊单  1 获取2 不获取*/
                    isInterrogationsingle: '1',
                    /*问诊单   1只获取选择的答案2只获取不选择的答案 不传获取全部 */
                    ischecked: '1',
                    getPatient:'1',
                }

                this.$doRequest("/api/Inquiry/orderDetails", params, res=>{
                    this.doctor = res.doctor;//医生信息
                    this.patient = res.patient;//患者信息
                    this.orderinfo = res.orderinfo;//订单信息
                    this.buyedtime=this.orderinfo.buytime;
                    this.orderinfo.buytime = common.timestampToTime(this.orderinfo.buytime,2);
                    this.orderinfo.paytime = common.timestampToTime(this.orderinfo.paytime,2);

                })
            },
          goEvaluate(e){
              if(this.orderinfo.orderstate=='2'){
                this.$toastMsg("此订单正处于问诊中暂不能评价");
                return;
              }
              if(e.isComment==2&&this.orderinfo.orderstate=='3'){
                this.$router.push({path:'/judgement',query:{id:e.id,selecttype:'WZ'}});
              }else{
                this.$toastMsg("请勿重复评论");
                return;
              }

          },
          goChat(e){
             this.$store.state.AllOfValue.ImDoctorInfo={
               doctorId:this.doctor.doctorId,
               doctorName:this.doctor.doctorName,
               inquiryPatientId:e.patientid,
               inquiryPatientName:this.patient.patientname,
               isOrder:this.doctor.isOrder,
               otime:this.buyedtime,
               orderid:e.id,
             };
            this.$store.state.AllOfValue.doctorId = this.doctor.doctorId;
            this.$store.state.tabIndex= 'immsg';
            this.$router.push({ path: "/im" });
          }
        },
        //生命周期之创建完成
        created: function(){
            this.$isLogin(window.location.search.substr(1), this.getOrderDetails);
            document.title = '订单详情';
        },
    }



// WEBPACK FOOTER //
// ./src/views/myOrderDetailsWZ/index.vue